// extracted by mini-css-extract-plugin
module.exports = {"wcs4idl":"wcs4idl"};